// Centralized API Configuration
// All endpoints routed through unified API Gateway: api.peaknet.com.au

const API_BASE = 'https://api.peaknet.com.au';

export const API_ENDPOINTS = {
  // Auth
  LOGIN: `${API_BASE}/auth/login`,
  CHECK_EMAIL: `${API_BASE}/auth/check-email`,

  // Users
  GET_USER: `${API_BASE}/users/get`,
  CUSTOMER_PORTAL: `${API_BASE}/users/portal`,

  // Plans
  PLAN_MANAGEMENT: `${API_BASE}/plans`,
  PLAN_UPGRADE: `${API_BASE}/plans/upgrade`,

  // Billing
  RECURRING_BILLING: `${API_BASE}/billing/recurring`,
  ADMIN_BILLING_MANAGEMENT: `${API_BASE}/billing/management`,
  ADMIN_TRIGGER_BILLING: `${API_BASE}/billing/recurring`,
  ADMIN_FULL_BILLING_RUN: `${API_BASE}/billing/recurring`,
  ADMIN_BILLING_HISTORY: `${API_BASE}/admin/get-customers`,

  // NBN
  VOCUS_AVAILABILITY: `${API_BASE}/nbn/check-availability`,
  VOCUS_DIAGNOSTICS: `${API_BASE}/admin/nbn/diagnostics`,

  // Signup (dynamic getter for backward compat)
  get SIGNUP() {
    return `${API_BASE}/auth/signup`;
  },

  // IT Services
  IT_SERVICES_QUOTE_MANAGEMENT: `${API_BASE}/itservices/quotes`,
  IT_SERVICES_INVOICE: `${API_BASE}/itservices/invoices`,
  IT_SERVICES_PAYMENT: `${API_BASE}/itservices/payments`,
  IT_SERVICES_CUSTOMER_MANAGEMENT: `${API_BASE}/itservices/customers`,
  IT_SERVICES_CONTACT_FORM: `${API_BASE}/itservices/contact`,

  // Contracts
  CONTRACT_MANAGEMENT: `${API_BASE}/contracts`,

  // Tickets
  TICKET_MANAGEMENT: `${API_BASE}/tickets`,

  // Webhooks
  WEBHOOKS: `${API_BASE}/webhooks/stripe`,

  // Admin - Auth & User Management
  ADMIN_AUTH: `${API_BASE}/admin/auth`,
  ADMIN_USER_MANAGEMENT: `${API_BASE}/admin/users`,
  ADMIN_PERMISSIONS: `${API_BASE}/admin/permissions`,
  ROLE_PERMISSIONS_MANAGEMENT: `${API_BASE}/admin/roles`,

  // Admin - Customer Management
  ADMIN_GET_CUSTOMERS: `${API_BASE}/admin/get-customers`,
  ADMIN_SEND_EMAIL: `${API_BASE}/admin/get-customers`,
  ADMIN_APPROVE_CUSTOMER: `${API_BASE}/admin/get-customers`,
  ADMIN_CUSTOMER_ACTION: `${API_BASE}/admin/get-customers`,
  SEND_WELCOME_EMAIL: `${API_BASE}/admin/get-customers`,
  ADMIN_CUSTOMER_MANAGEMENT: `${API_BASE}/admin/customers`,
  ADMIN_ACTION_HISTORY: `${API_BASE}/admin/customers`,

  // Admin - Templates & Reminders
  ADMIN_TEMPLATES: `${API_BASE}/admin/templates`,
  ADMIN_REMINDER_SETTINGS_CONTRACTS: `${API_BASE}/admin/reminders/contracts`,
  ADMIN_REMINDER_SETTINGS_ITSERVICES: `${API_BASE}/admin/reminders/itservices`,

  // SEO metrics — Lighthouse/CWV history collected server-side so the PageSpeed
  // API key never ships in this (publicly downloadable) admin bundle.
  ADMIN_SEO_METRICS: `${API_BASE}/admin/seo/metrics`,
  ADMIN_SEO_METRICS_URLS: `${API_BASE}/admin/seo/metrics/urls`,
  ADMIN_SEO_METRICS_COLLECT: `${API_BASE}/admin/seo/metrics/collect`,

  // Admin - Vendor Invoices
  VENDOR_INVOICE_MANAGEMENT: `${API_BASE}/admin/vendor-invoices`,
  VENDOR_INVOICE_PAYMENT: `${API_BASE}/admin/vendor-payments`,
};

// Legacy export for backward compatibility (used by admin BillingManagement)
export const API_CONFIG = {
  RECURRING_BILLING: `${API_BASE}/billing`,
};

export default API_ENDPOINTS;
